import PostsSubmissionPartial from "../../partials/campaign/post-submission.partial";

export default function PostSubmissionScreen() {
  return <PostsSubmissionPartial />;
}
